import Roles from 'modules/Roles/index'
import { connect } from 'react-redux'

import rolesSelectors from 'modules/Roles/selectors'

import {
  closeApplication,
  deleteRole,
  duplicateRole,
  getCorporateMetricsData,
  getJobsList,
  getSingleRoleData,
  setCurrentJobId,
  setEditRoleOnView,
  setEditingRole,
  setPreviewRoleData,
  setSingleRoleData,
  getRoleCityData,
  getRoleDraftData,
  setDraftData,
} from 'modules/Roles/actions'

import { setDashboardNavs } from 'modules/Auth/actions'
import authSelector from 'modules/Auth/selectors'
import { getNotificationCatalogues } from 'modules/Users/actions'

const mapStateToProps = state => ({
  corporateMetrics: rolesSelectors.getCorporateMetrics(state),
  currentJobId: rolesSelectors.getCurrentJobId(state),
  jobsList: rolesSelectors.getJobsList(state),
  dashboardNavs: authSelector.getDashboardNavs(state),
  permissions: authSelector.getUserPermissions(state),
  draftData: rolesSelectors.getRoleDraftData(state),
})

const mapDispatchToProps = {
  getCorporateMetricsData,
  getJobsList,
  closeApplication,
  duplicateRole,
  deleteRole,
  getSingleRoleData,
  setEditingRole,
  setCurrentJobId,
  setSingleRoleData,
  setEditRoleOnView,
  setPreviewRoleData,
  setDashboardNavs,
  getNotificationCatalogues,
  getRoleCityData,
  getRoleDraftData,
  setDraftData,
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles)
